class SunfadeCollectionNav extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('[data-sunfade-collection-trigger]')];
    this.panels = [...this.querySelectorAll('[data-sunfade-collection-panel]')];
    this.backdrop = document.querySelector('[data-sunfade-collection-backdrop]');

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onBackdropClick = this.closeAll.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    this.triggers.forEach((trigger) => trigger.addEventListener('click', this.onTriggerClick));
    this.backdrop?.addEventListener('click', this.onBackdropClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.onTriggerClick));
    this.backdrop?.removeEventListener('click', this.onBackdropClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
    document.removeEventListener('click', this.onDocumentClick);
  }

  onTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const trigger = event.currentTarget;
    const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
    this.closeAll();

    if (!shouldOpen) return;

    const panel = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
    if (!panel) return;

    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    this.setAttribute('data-open', '');

    if (this.backdrop) {
      this.backdrop.hidden = false;
    }
  }

  onDocumentClick(event) {
    if (this.hasAttribute('data-open') && !this.contains(event.target)) {
      this.closeAll();
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      const activeTrigger = this.triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true');
      this.closeAll();
      activeTrigger?.focus();
    }
  }

  closeAll() {
    this.triggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    this.panels?.forEach((panel) => {
      panel.hidden = true;
    });
    this.removeAttribute('data-open');

    if (this.backdrop) {
      this.backdrop.hidden = true;
    }
  }
}

if (!customElements.get('sunfade-collection-nav')) {
  customElements.define('sunfade-collection-nav', SunfadeCollectionNav);
}
